import { tv } from "@/utils/tv.config";
import { VariantProps } from "tailwind-variants";

export const typographyClasses = tv({
  base: ["Typography__root normal-case drop-shadow-sm"],
  variants: {
    variant: {
      h1: "text-[2.5rem] font-bold",
      h2: "text-3xl font-bold",
      h3: "text-2xl font-semi-bold",
      h4: "text-[1.375rem] font-semi-bold",
      h5: "text-xl font-medium",
      h6: "text-lg font-medium",
      subtitle1: "text-lg font-normal",
      subtitle2: "text-lg font-normal",
      body1: "text-sm",
      body2: "text-sm font-light",
      caption: ["text-xs font-light"],
      overline: ["text-xs uppercase tracking-widest font-light"],
      inherit: "text-inherit",
    },
    weight: {
      light: "font-light",
      regular: "font-normal",
      medium: "font-medium",
      bold: "font-bold",
    },
    italic: {
      true: ["italic"],
    },
    truncate: {
      true: ["truncate"],
    },
    textTransform: {
      uppercase: ["uppercase"],
      lowercase: ["lowercase"],
      capitalize: ["capitalize"],
    },
    align: {
      left: "text-left",
      right: "text-right",
      center: "text-center",
      inherit: "text-inherit",
    },
    gutterBottom: {
      true: ["mb-4"],
    },
    color: {
      primary: ["text-primary-main"],
      secondary: ["text-secondary-main"],
      success: ["text-success-main"],
      warning: ["text-warning-main"],
      info: ["text-info-main"],
      error: ["text-error-main"],
      inherit: ["text-inherit"],
    },
  },
  compoundVariants: [
    {
      variant: "h1",
      gutterBottom: true,
      className: "mb-2",
    },
    {
      variant: "h2",
      gutterBottom: true,
      className: "mb-2",
    },
    {
      variant: "h3",
      gutterBottom: true,
      className: "mb-2",
    },
    {
      variant: "h4",
      gutterBottom: true,
      className: "mb-2",
    },
    {
      variant: "h5",
      gutterBottom: true,
      className: "mb-2",
    },
    {
      variant: "h6",
      gutterBottom: true,
      className: "mb-2",
    },
  ],
  defaultVariants: {
    variant: "body1",
    fontWeight: "regular",
  },
});

export type TypographyVariants = VariantProps<typeof typographyClasses>;
